"use strict";

exports.__esModule = true;
exports.USER_PRIVACY_STATUS_PUBLIC = exports.USER_PRIVACY_STATUS_PRIVATE = void 0;
var USER_PRIVACY_STATUS_PRIVATE = 'PRIVATE';
exports.USER_PRIVACY_STATUS_PRIVATE = USER_PRIVACY_STATUS_PRIVATE;
var USER_PRIVACY_STATUS_PUBLIC = 'PUBLIC';
exports.USER_PRIVACY_STATUS_PUBLIC = USER_PRIVACY_STATUS_PUBLIC;